import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CategoryInterface } from 'type/categoryType';
import { TableColumnInterface } from 'type/tableType';
import * as Component from '../../../../shared/components';
import { categoryService } from '../services/categoryService';

export default function Category(): React.JSX.Element {
  const columns: TableColumnInterface<CategoryInterface>[] = [
    {
      title: 'NAME',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: CategoryInterface, b: CategoryInterface) => a.name.localeCompare(b.name),
      render: (text: string) => text.toLowerCase(),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
  ];

  const [searchParams, setSearchParams] = useSearchParams();

  const fetchCategoryList = async (
    params: URLSearchParams
  ): Promise<{ data: CategoryInterface[]; count: number }> => {
    return await categoryService.fetch(params);
  };

  return (
    <Component.BasePageComponent>
      <Component.TableComponent<CategoryInterface>
        name="Category"
        dataFetch={fetchCategoryList}
        columns={columns}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
      />
    </Component.BasePageComponent>
  );
}
